<template>
  <ContextualRouterLink :to='props.href' class="rounded-md bg-jananavy-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-jananavy-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-jananavy-600">
    <slot />
  </ContextualRouterLink>
</template>

<script setup>

import ContextualRouterLink from '@/components/links/contextual-router-link.vue';

const props = defineProps({
  href: String
});

</script>
